import {strokeReferences,type TheoryResources} from './learning-theory';
// Never enrich an issued item using a newer lesson revision.
export function theoryResources(content:any,issuedRevision:string|undefined):TheoryResources {
 if(!issuedRevision||content?.lessonRevisionId!==issuedRevision)return {};
 const strokes:Record<string,string>={};
 for(const section of content.sections??[])for(const item of section.items??[]){
  Object.assign(strokes,strokeReferences(item.content?.bodyMarkdown??''));
 }
 // Lesson content exposes exercise revision IDs, not adjacent public payloads.
 // Do not infer pronunciation audio from them or from approximate pinyin.
 return {strokes};
}
